<template>
  <div class="min-h-screen bg-slate-50">
    <main class="max-w-xl mx-auto px-4 py-10">
        <div class="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden min-h-[300px] flex items-center justify-center">
            <div class="flex flex-col items-center justify-center gap-3">
                <div class="loader"></div>
                <span class="text-slate-800 font-medium">Loading...</span>
            </div>
        </div>
    </main>
  </div>
</template>

<script> 

import api from '../api/http'

export default {
  name: "Czp",
  data() {
    return {
      data: null,
      userID: false,
      imgLogo: require("../assets/public/Logo ODOS.png"),
    }
  },
  mounted() {
    this.getData();
  },
  methods: {

    async getData() {
        if (this.$route.query.mToken) {
          const appId = this.$route.query.appId;
          const mToken = this.$route.query.mToken;

          const url = "/czpcheckuser?appId=" + appId + "&mToken=" + mToken;

            try {
              const resp = await api.get(url)                 
              if (resp.data.responsecode == 200) {
                  const data = resp.data.data.message
                  
                  this.$router.push({ 
                      path: "/register", 
                      query: { 
                          citizenId: data.citizenId,
                          firstName: data.firstName,
                          lastName: data.lastName,
                          email: data.email,
                          mobile: data.mobile,
                          birthDate: data.dateOfBirthString 
                      } 
                  })
                  // await this.$store.dispatch("/register", {
                  //     citizenId: data.citizenId,
                  //     firstName: data.firstName,
                  //     lastName: data.lastName,
                  //     email: data.email,
                  //     mobile: data.mobile,
                  //     birthDate: data.dateOfBirthString

                  // });
              } else {
                  this.error = "ไม่พบข้อมูล"
              }
          } catch (e) {
              console.error("API error", e)
              this.error = "เกิดข้อผิดพลาด"
          }
      }
    },
  }
};


</script>
<style scoped>
.loader {
  border: 8px solid #f3f3f3;      
  border-top: 8px solid #FFF200;  
  border-radius: 50%;
  width: 64px;
  height: 64px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>

